"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var styled_components_1 = __importDefault(require("styled-components"));

var baseStyle = "\n    font-weight: 900;\n    line-height: 1.15;\n"; // The font sizes are not arbitral value, they were generated from type-scale.com- where the base size was provided by the design system

exports.base16typeScale = {
  h1: '3.052em',
  h2: '2.441em',
  h3: '1.953em',
  h4: '1.563em',
  h5: '1.25em',
  h6: '1em'
};
exports.base18typeScale = {
  h1: '1.802em',
  h2: '1.602em',
  h3: '1.424em',
  h4: '1.266em',
  h5: '1.125em',
  h6: '1em'
};
/**
 *
 * @visibleName Headings
 */

exports.H1 = styled_components_1.default.h1(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    ", "\n    font-family: ", ";\n    color: ", ";\n    text-transform: ", ";\n    font-size: ", ";\n    margin: ", " 0px;\n    @media only screen and (max-width: 360px) and (hover: none) and (pointer: coarse) {\n        font-size: ", ";\n    }\n    @media only screen and (min-width: 360px) and (hover: none) and (pointer: coarse) {\n        font-size: ", ";\n    }\n"], ["\n    ", "\n    font-family: ", ";\n    color: ", ";\n    text-transform: ", ";\n    font-size: ", ";\n    margin: ", " 0px;\n    @media only screen and (max-width: 360px) and (hover: none) and (pointer: coarse) {\n        font-size: ", ";\n    }\n    @media only screen and (min-width: 360px) and (hover: none) and (pointer: coarse) {\n        font-size: ", ";\n    }\n"])), baseStyle, function (_a) {
  var theme = _a.theme;
  return theme.fontText;
}, function (_a) {
  var theme = _a.theme;
  return theme.palette.primary.text;
}, function (props) {
  return props.textTransform;
}, exports.base16typeScale.h1, function (_a) {
  var theme = _a.theme;
  return theme.component.margin;
}, exports.base18typeScale.h1, exports.base16typeScale.h1);
exports.H2 = styled_components_1.default.h2(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    ", "    \n    font-family: ", ";\n    color: ", ";\n    text-transform: ", ";\n    font-size: ", ";\n    margin: ", " 0px;\n    @media only screen and (max-width: 360px) and (hover: none) and (pointer: coarse) {\n        font-size: ", ";\n    }\n    @media only screen and (min-width: 360px) and (hover: none) and (pointer: coarse) {\n        font-size: ", ";\n    }\n"], ["\n    ", "    \n    font-family: ", ";\n    color: ", ";\n    text-transform: ", ";\n    font-size: ", ";\n    margin: ", " 0px;\n    @media only screen and (max-width: 360px) and (hover: none) and (pointer: coarse) {\n        font-size: ", ";\n    }\n    @media only screen and (min-width: 360px) and (hover: none) and (pointer: coarse) {\n        font-size: ", ";\n    }\n"])), baseStyle, function (_a) {
  var theme = _a.theme;
  return theme.fontText;
}, function (_a) {
  var theme = _a.theme;
  return theme.palette.primary.text;
}, function (props) {
  return props.textTransform;
}, exports.base16typeScale.h2, function (_a) {
  var theme = _a.theme;
  return theme.component.margin;
}, exports.base18typeScale.h2, exports.base16typeScale.h2);
exports.H3 = styled_components_1.default.h3(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    ", "\n    font-family: ", ";\n    color: ", ";\n    text-transform: ", ";\n    font-size: ", ";\n\n    margin: ", " 0px;\n    @media only screen and (max-width: 360px) and (hover: none) and (pointer: coarse) {\n        font-size: ", ";\n    }\n    @media only screen and (min-width: 360px) and (hover: none) and (pointer: coarse) {\n        font-size: ", ";\n    }\n"], ["\n    ", "\n    font-family: ", ";\n    color: ", ";\n    text-transform: ", ";\n    font-size: ", ";\n\n    margin: ", " 0px;\n    @media only screen and (max-width: 360px) and (hover: none) and (pointer: coarse) {\n        font-size: ", ";\n    }\n    @media only screen and (min-width: 360px) and (hover: none) and (pointer: coarse) {\n        font-size: ", ";\n    }\n"])), baseStyle, function (_a) {
  var theme = _a.theme;
  return theme.fontText;
}, function (_a) {
  var theme = _a.theme;
  return theme.palette.primary.text;
}, function (props) {
  return props.textTransform;
}, exports.base16typeScale.h3, function (_a) {
  var theme = _a.theme;
  return theme.component.margin;
}, exports.base18typeScale.h3, exports.base16typeScale.h3);
exports.H4 = styled_components_1.default.h4(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    ", "\n    font-family: ", ";\n    color: ", ";\n    text-transform: ", ";\n    font-size: ", ";\n    margin: ", " 0px;\n    @media only screen and (max-width: 360px) and (hover: none) and (pointer: coarse) {\n        font-size: ", ";\n    }\n    @media only screen and (min-width: 360px) and (hover: none) and (pointer: coarse) {\n        font-size: ", ";\n    }\n"], ["\n    ", "\n    font-family: ", ";\n    color: ", ";\n    text-transform: ", ";\n    font-size: ", ";\n    margin: ", " 0px;\n    @media only screen and (max-width: 360px) and (hover: none) and (pointer: coarse) {\n        font-size: ", ";\n    }\n    @media only screen and (min-width: 360px) and (hover: none) and (pointer: coarse) {\n        font-size: ", ";\n    }\n"])), baseStyle, function (_a) {
  var theme = _a.theme;
  return theme.fontText;
}, function (_a) {
  var theme = _a.theme;
  return theme.palette.primary.text;
}, function (props) {
  return props.textTransform;
}, exports.base16typeScale.h4, function (_a) {
  var theme = _a.theme;
  return theme.component.margin;
}, exports.base18typeScale.h4, exports.base16typeScale.h4);
exports.H5 = styled_components_1.default.h5(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    ", "\n    font-family: ", ";\n    color: ", ";\n    text-transform: ", ";\n    font-size: ", ";\n    @media only screen and (max-width: 360px) and (hover: none) and (pointer: coarse) {\n        font-size: ", ";\n    }\n    @media only screen and (min-width: 360px) and (hover: none) and (pointer: coarse) {\n        font-size: ", ";\n    }\n"], ["\n    ", "\n    font-family: ", ";\n    color: ", ";\n    text-transform: ", ";\n    font-size: ", ";\n    @media only screen and (max-width: 360px) and (hover: none) and (pointer: coarse) {\n        font-size: ", ";\n    }\n    @media only screen and (min-width: 360px) and (hover: none) and (pointer: coarse) {\n        font-size: ", ";\n    }\n"])), baseStyle, function (_a) {
  var theme = _a.theme;
  return theme.fontText;
}, function (_a) {
  var theme = _a.theme;
  return theme.palette.primary.text;
}, function (props) {
  return props.textTransform;
}, exports.base16typeScale.h5, exports.base18typeScale.h5, exports.base16typeScale.h5);
exports.H6 = styled_components_1.default.h6(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    ", "\n    font-family: ", ";\n    color: ", ";\n    text-transform: ", ";\n    font-size: ", ";\n    margin: ", " 0px;\n    @media only screen and (max-width: 360px) and (hover: none) and (pointer: coarse) {\n        font-size: ", ";\n    }\n    @media only screen and (min-width: 360px) and (hover: none) and (pointer: coarse) {\n        font-size: ", ";\n    }\n"], ["\n    ", "\n    font-family: ", ";\n    color: ", ";\n    text-transform: ", ";\n    font-size: ", ";\n    margin: ", " 0px;\n    @media only screen and (max-width: 360px) and (hover: none) and (pointer: coarse) {\n        font-size: ", ";\n    }\n    @media only screen and (min-width: 360px) and (hover: none) and (pointer: coarse) {\n        font-size: ", ";\n    }\n"])), baseStyle, function (_a) {
  var theme = _a.theme;
  return theme.fontText;
}, function (_a) {
  var theme = _a.theme;
  return theme.palette.primary.text;
}, function (props) {
  return props.textTransform;
}, exports.base16typeScale.h6, function (_a) {
  var theme = _a.theme;
  return theme.component.margin;
}, exports.base18typeScale.h6, exports.base16typeScale.h6);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;